module.exports = __webpack_public_path__ + "img/_Generic1.2a788c7a.jpg";